import firebase from 'firebase'
import 'firebase/firestore'

// firebase init goes here
const config = {
  apiKey: 'AIzaSyBY-V3_eNaUDMrmvdUFfy54FdMKEQO4tR4',
  authDomain: 'git-gud-scrub.firebaseapp.com',
  databaseURL: 'https://git-gud-scrub.firebaseio.com',
  projectId: 'git-gud-scrub',
  storageBucket: 'git-gud-scrub.appspot.com',
  messagingSenderId: '775169276117'
}

firebase.initializeApp(config)

// firebase utils
const db = firebase.firestore()
const auth = firebase.auth()
const currentUser = auth.currentUser

// date issue fix according to firebase
const settings = {
}
db.settings(settings)

// firebase collections
const usersCollection = db.collection('users')

export {
  firebase,
  db,
  auth,
  currentUser,
  usersCollection
}
